import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import React from 'react';
import { Tooltip } from './Tooltip.js';
import { jsx } from '@emotion/react';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';
import { LiveRegion } from '../LiveRegion/LiveRegion.js';
import './PopupTooltip.js';
import '../../index-D7dZz-Df.js';
import '../../utils/mergeRefs.js';
import 'use-debounce';
import '@indeed/ihl-use-id';
import '../../utils/transition.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../Popup/Popup.js';
import '@floating-ui/react-dom';
import '@indeed/ifl-css';
import '../../hooks/useMergeRefs.js';
import '../Box/Box.js';
import '../Portal/Portal.js';
import 'react-dom';
import '../IndeedThemeProvider/IndeedThemeProvider.js';
import '@indeed/ifl-icons';
import '../IndeedThemeProvider/utils.js';
import '../IndeedThemeProvider/theme.js';
import 'deepmerge';
import '@indeed/ifl-themes';
import '../LinkProvider/LinkProvider.js';

const ToggleTooltip = _ref => {
  let {
    label,
    onHide = () => {},
    onShow = () => {},
    ...props
  } = _ref;
  const [visible, setVisible] = React.useState(false);
  return jsx(React.Fragment, null, jsx(Tooltip, _extends({
    aria: {
      content: null,
      expanded: true
    },
    label: label,
    onHide: () => (onHide() ?? true) && setVisible(false),
    onShow: () => (onShow() ?? true) && setVisible(true),
    popupProps: {
      "aria-hidden": true,
      tabIndex: -1
    },
    trigger: "click touch"
  }, props)), visible ? jsx(VisuallyHidden, null, jsx(LiveRegion, null, jsx("span", null, label))) : null);
};

export { ToggleTooltip };
